import * as React from "react";

const BillingInvoiceIconSvg = ({ pathNames, color }) => {
  const isActive = pathNames === "/home/invoices";
  const strokeColor = isActive ? "#ffffff" : color ? color : "#667085";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Receipt with dollar sign */}
      <path
        d="M15 17.5L13.3333 16.25L11.6667 17.5L10 16.25L8.33333 17.5L6.66667 16.25L5 17.5V3.33333C5 2.8731 5.3731 2.5 5.83333 2.5H14.1667C14.6269 2.5 15 2.8731 15 3.33333V17.5Z"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 7.08333C11.25 6.39298 10.6904 5.83333 10 5.83333C9.30964 5.83333 8.75 6.39298 8.75 7.08333C8.75 7.77369 9.30964 8.33333 10 8.33333"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8.33333C10.6904 8.33333 11.25 8.89298 11.25 9.58333C11.25 10.2737 10.6904 10.8333 10 10.8333C9.30964 10.8333 8.75 10.2737 8.75 9.58333"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5V5.83333M10 10.8333V11.6667"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M7.5 13.75H12.5"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BillingInvoiceIconSvg;
